// Utility functions for working with FDA 510k decision letter search results
export function filterByProductCode(searchResults, productCode) {
    return Array.isArray(searchResults)
    ? searchResults.filter(r => r.productCode === productCode)
    : [];
};

 export function filterCandidates(searchResults) {
    return (Array.isArray(searchResults) ? searchResults : []).filter(c => c?.isCandidate === "Yes");
 };